import {Component} from '@angular/core';
import {BaseAppointmentComponent} from "../base-appointment.component";
import {ActivatedRoute} from "@angular/router";
import {Subscription} from "rxjs";
import {MatIconModule} from "@angular/material/icon";
import {MatButtonModule} from "@angular/material/button";
import {MatTooltipModule} from "@angular/material/tooltip";
import {NoteElementComponent} from "./note-element/note-element.component";
import {FeedbackButtonComponent} from "../../../components/feedback-button/feedback-button.component";


/** Shows a pre-visit not to the user (maybe adapted later for showing enhanced note too) */
@Component({
	selector: 'app-note',
	imports: [
		MatIconModule,
		MatButtonModule,
		MatTooltipModule,
		NoteElementComponent,
		FeedbackButtonComponent
	],
	templateUrl: './note.component.html',
	styleUrl: './note.component.scss'
})
export class NoteComponent extends BaseAppointmentComponent {
	/** The root note categories in order to display on the page */
	templates:NoteDisplay[];

	/** Currently loaded note data */
	noteData:string;

	/** Is this a pre-visit or a post-visit note */
	isPreVisit:boolean;

	/** Data listening subscription */
	private dataSubscription:Subscription;

	constructor(private route:ActivatedRoute) {
		super();
	}

	override ngOnInit() {
		super.ngOnInit();

		//listen for a data change (handle switching between pre-visit and post-visit notes
		this.dataSubscription = this.route.data.subscribe((data) => {
			const isPreVisit = data["isPreVisit"] === true;

			//if there is a change, then update
			if(isPreVisit != this.isPreVisit) {
				this.isPreVisit = isPreVisit;

				//make sure data is set
				if(this.data) {
					this.onNewAppointmentData();
				}
			}
		});

	}

	override ngOnDestroy() {
		super.ngOnDestroy();

		this.dataSubscription?.unsubscribe();
	}

	override onNewAppointmentData() {
		//Wait for data to be initialized
		if(this.isPreVisit === undefined) {
			return;
		}

		//get the note's data
		const noteData = this.isPreVisit ? this.preVisit : this.postVisit;

		//if the note changed
		if(noteData !== this.noteData) {
			this.noteData = noteData;

			//parse the xml to make some changes to it
			const parser = new DOMParser();
			const doc = parser.parseFromString(this.noteData, "application/xml");

			//get all the root category divs
			const categories = doc.querySelectorAll(":scope > div");
			this.templates = [];

			//for each get the heading and remove it
			categories.forEach(category => {
				const heading = category.querySelector(":scope > h2");
				heading.remove();

				this.templates.push({
					name: heading.textContent,
					shortName: category.getAttribute("id"),
					content: category.innerHTML
				});
			});
		}
	}
}

/** Display of a note element/category on the note page */
export interface NoteDisplay {
	/** The full name of the category */
	name:string;

	/** An abbreviation for the category or a shorter name */
	shortName:string;

	/** HTML content of the section */
	content:string;
}
